import $ from 'jquery';
import { Controller } from 'stimulus';
import AwesompleteWrapper from '../helpers/awesompleteWrapper';

class SearchController extends Controller {
  connect() {
    this.isOpen = false;
    this.apiUrl = '/zoeken?q=';
    this.lang = document.querySelector('html').lang;

    this.awesomplete = new AwesompleteWrapper({
      inputElement: this.inputTarget,
      itemRenderer: this.renderItem.bind(this),
      api: this.apiUrl,
      replace: this.replace.bind(this),
    });
  }

  renderItem(obj, list) {
    const {
      url,
      type,
      title,
      image,
      measurements,
    } = obj.label;

    const firstOfType = this.firstOfType(obj.label, list);

    let typeElement = '';
    let imageElement = '';
    let measurementsElement = '';

    if (image) {
      imageElement = SearchController.renderImage(image);
    }

    if (firstOfType) {
      const typeTranslation = {
        product: 'Producten',
        category: 'Categorieën',
        article: 'Artikelen',
      };

      typeElement = `
        <div class="awesomplete__result-head">
          ${typeTranslation[type]}
        </div>
      `;
    }

    if (measurements) {
      measurementsElement = `
        <div class="awesomplete__result-measurements">
          ${measurements}
        </div>
      `;
    }

    return `
      ${typeElement}

      <a href="${url}" class="awesomplete__result">
        ${imageElement}

        <div class="awesomplete__result-content">
          <strong class="d-block">${title}</strong>

          ${measurementsElement}
        </div>
      </a>
    `;
  }

  // eslint-disable-next-line class-methods-use-this
  firstOfType(item, list) {
    if (typeof list === 'undefined' || !list || typeof item === 'undefined' || !item) {
      return false;
    }

    const firstOfTypeLabels = [];
    let lastType = '';

    list.forEach((listItem) => {
      if (typeof listItem.type === 'undefined' || typeof listItem.id === 'undefined') {
        return;
      }

      const listItemType = listItem.type;

      if (listItemType !== lastType) {
        lastType = listItemType;
        firstOfTypeLabels.push(listItem.id);
      }
    });

    return firstOfTypeLabels.indexOf(item.id) >= 0;
  }

  static renderImage(image) {
    return `
      <div class="awesomplete__image">
        <img class="absolute-center" src="${image}" alt="">
      </div>
    `;
  }

  replace(obj) {
    if (typeof obj.value.url !== 'undefined') {
      window.location = obj.value.url;
      return;
    }

    this.inputTarget.value = obj.value.label;

    const $form = $(this.inputTarget).parents('form');

    if ($form.length) {
      $form.submit();
    }
  }
}

SearchController.targets = [
  'input',
];

export default SearchController;
